import React from "react";
import { useState } from "react";
import Lightbox from "../../components/common/Lightbox/Lightbox";

const PortfolioBanner = ({ images = [] }) => {
  const [showPreview, setShowPreview] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  // Use provided images or fallback to default images
  const Images = images.length > 0 ? images : [
    {
      original: require("../../assets/img/default-image.jpg"),
      thumbnail: require("../../assets/img/default-image.jpg"),
    }
  ];

  const handleImageClick = (index) => {
    setImageIndex(index);
    setShowPreview(true);
  };

  return (
    <>
      {showPreview && (
        <Lightbox
          images={Images.map(img => img.original)}
          initialIndex={imageIndex}
          onClose={() => setShowPreview(false)}
        />
      )}
      <div className="w-full sm:h-auto sm:aspect-[1024/768]">
        <img
          className="cursor-pointer rounded-xl object-cover w-full h-full"
          onClick={() => handleImageClick(0)}
          src={Images[0]?.original || require("../../assets/img/default-image.jpg")}
          alt="product images"
          onError={(e) => {
            e.target.src = require("../../assets/img/default-image.jpg");
          }}
        />
      </div>
    </>
  );
};

export default PortfolioBanner;
